function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27 13.5C27 15.9853 24.9853 18 22.5 18C20.0147 18 18 15.9853 18 13.5C18 11.0147 20.0147 9 22.5 9C24.9853 9 27 11.0147 27 13.5ZM23 11.5C23 11.2239 22.7761 11 22.5 11C22.2239 11 22 11.2239 22 11.5V13H20.5C20.2239 13 20 13.2239 20 13.5C20 13.7761 20.2239 14 20.5 14H22V15.5C22 15.7761 22.2239 16 22.5 16C22.7761 16 23 15.7761 23 15.5V14H24.5C24.7761 14 25 13.7761 25 13.5C25 13.2239 24.7761 13 24.5 13H23V11.5ZM22.5 19C23.02 19 23.5232 18.9278 24 18.793V19C24 20.1046 23.1046 21 22 21H21C20.4477 21 20 20.5523 20 20V18.4003C20.7501 18.7837 21.5998 19 22.5 19ZM18.2528 10.0052C17.9971 10.3156 17.7748 10.6545 17.5913 11.0165C15.0211 11.2244 13 13.3762 13 16H15C15.5523 16 16 16.4477 16 17V20C16 20.5523 15.5523 21 15 21H13V22C13 23.1046 13.8954 24 15 24H16C16 22.8954 16.8954 22 18 22C19.1046 22 20 22.8954 20 24C20 25.1046 19.1046 26 18 26C17.2597 26 16.6134 25.5978 16.2676 25H15C13.3431 25 12 23.6569 12 22V16C12 12.6863 14.6863 10 18 10C18.0847 10 18.169 10.0018 18.2528 10.0052Z",
  fill: "#AA50E2"
});

function SvgBarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarge);
export default __webpack_public_path__ + "static/media/barge.d054c071.svg";
export { ForwardRef as ReactComponent };